// core packages
import * as apollo from '@apollo/client';

// utilities
import * as utilities from '@apollo/client/utilities';

// errors and links
import * as context from '@apollo/client/link/context';
import * as core from '@apollo/client/core/watchQueryOptions';
import * as error from '@apollo/client/link/error';
import * as retry from '@apollo/client/link/retry';
import * as ws from '@apollo/client/link/ws';

export type Client = typeof apollo.ApolloClient;

export type LazyQueryResult<TData, TVariables extends apollo.OperationVariables> = apollo.QueryResult<TData, TVariables>;
export type NormalizedCacheObject = apollo.NormalizedCacheObject;
export type ApolloClient<T> = apollo.ApolloClient<T>;
export type WatchQueryFetchPolicy = core.WatchQueryFetchPolicy;
export type DeepPartial<T> = utilities.DeepPartial<T>;
export type ApolloQueryResult<T> = apollo.ApolloQueryResult<T>;
export type ApolloLink = apollo.ApolloLink;

export const ApolloClient = apollo.ApolloClient;
export const ApolloLink = apollo.ApolloLink;
export const InMemoryCache = apollo.InMemoryCache;
export const HttpLink = apollo.HttpLink;
export const NetworkStatus = apollo.NetworkStatus;
export const ApolloProvider = apollo.ApolloProvider;
export const from = apollo.from;
export const split = apollo.split;
export const useLazyQuery = apollo.useLazyQuery;
export const useMutation = apollo.useMutation;
export const useQuery = apollo.useQuery;
export const useSubscription = apollo.useSubscription;
export const gql = apollo.gql;

export const getMainDefinition = utilities.getMainDefinition;
export const getOperationName = utilities.getOperationName;
export const relayStylePagination = utilities.relayStylePagination;

export const setContext = context.setContext;
export const onError = error.onError;
export const ErrorLink = error.ErrorLink;
export const RetryLink = retry.RetryLink;
export const WebSocketLink = ws.WebSocketLink;
